module.exports = __webpack_public_path__ + "img/clock-circle.1ee8b377.svg";